module.exports = __webpack_public_path__ + "media/images/shop_front-a20d720d20a7224fcc9c2567b4960f41.jpg";